import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./../common/reducers";
import { StoreState } from "./../common/types/index";
import { AllActions } from "./../common/actions/index";
import { allValuesForFilter } from "./../common/services/Filters";
import { composeEnhancers } from "../../src/config";

let aggReport: StoreState.Query["aggReport"] = "detail";
let initialQueryState = {
  filters: {
    startFailYear: "2012",
    endFailYear: new Date().getFullYear(),
    selectedStatesAlpha: allValuesForFilter("selectedStatesAlpha"),
    selectedInsuranceFunds: ["BIF", "RTC", "FSLIC", "SAIF", "DIF", "FDIC"],
    selectedCharterTypes: ["N", "SM", "NM", "SA", "SB"],
    selectedTransactionTypes: [
      "A/A",
      "REP",
      "P&A",
      "PA",
      "PI",
      "IDT",
      "MGR",
      "PO",
    ],
  },
  sort: {
    sortField: "FAILDATE",
    sortOrder: "desc",
  },
  fixedDisplayFields: [],
  displayFields: [
    "NAME",
    "CERT",
    "FIN",
    "CITYST",
    "FAILDATE",
    "SAVR",
    "RESTYPE",
    "COST",
    "RESTYPE1",
    "CHCLASS1",
    "QBFDEP",
    "QBFASSET",
  ],
  aggReport,
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};

export const initialState = {
  query: initialQueryState,
  ui: {
    filtersCollapsed: true,
    filterPanelDetail: false,
    filterPanelDetailSection: "",
    dataLoaded: true,
    requestInProgress: false,
    fields: [],
  },
  config: {
    docsPath: "/docs/failure_properties.yaml",
    apiPath: "/api/failures",
  },
  results: {},
  columns: null,
};

export const storeCreator = (initState: StoreState.All) => {
  return createStore<StoreState.All, AllActions, any, any>(
    rootReducer,
    initState,
    composeEnhancers(applyMiddleware(thunkMiddleware)),
  );
};
